const ListTable = require('app/ui/list/Table');
const ConfirmModal = require('app/ui/modal/Confirm');
const WaitingModal = require('app/ui/modal/Waiting');
const GraphQLMutation = require('app/graphql/Mutation');
const IFrame = require('app/ui/modal/IFrame');

const SendModal = require('app/billing/invoice/SendModal');
const ExportModal = require('app/billing/invoice/export/Modal');

class ListView {
    defaultOptions() {
        return {
            'selector': '.view-billing-invoice-list',
            'tableContainerSelector': '.billing-invoice-list-container',
            'filterFormSelector': '.billing-invoice-list-search-form',

            'billingInvoiceShowBaseUrl': window.App.get('billingInvoiceShowBaseUrl'),
            'billingPaymentListBaseUrl': window.App.get('billingPaymentListBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onClickExportLevies = this.onClickExportLevies.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
        this.$filterForm =  $(this.settings.filterFormSelector,this.$container);
        this.$btnExportLevies = $('.btn-billing-invoice-export-levies',this.$container);

        this.$btnGenerateInvoices = $('.btn-generate-invoices',this.$container);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeFilterForm();
        this.initializeListTable();
        this.bindEvents();
    }

    initializeFilterForm(){
        var self = this;

        this.$filterByDateFrom = $('input[name="dateFrom"]',this.$filterForm);
        this.$filterByDateFrom.on('change',this.onSubmitFilterForm);

        this.$filterByDateTo = $('input[name="dateTo"]',this.$filterForm);
        this.$filterByDateTo.on('change',this.onSubmitFilterForm);

        this.$filterBySearch = $('input[name="search"]',this.$filterForm);
        this.$filterBySearch.on('change',this.onSubmitFilterForm);

        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByReference.on('change',this.onSubmitFilterForm);

        this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
        this.$filterByRestaurant.on('change',this.onSubmitFilterForm);

        this.$filterByType = $('select[name="type"]',this.$filterForm); 
        this.$filterByType.on('change',this.onSubmitFilterForm);

        this.$filterByDeliveryNumber = $('input[name="deliveryNumber"]',this.$filterForm);
        this.$filterByDeliveryNumber.on('change',this.onSubmitFilterForm);

        this.$filterForm.on('submit',this.onSubmitFilterForm);

        window.select2(this.$filterByRestaurant);

    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'reference',
            'date',
            'customerName',
            'ht',
            'computedTva55',
            'computedTva20',
            'ttc',
            'locked',
            'customer { name email restaurantAssociations { restaurant{ email } } }'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped billing-invoice-list',
            'footerBuilder': {
                'mode': 'custom',
                'render': this.buildFooter,
            },
            'showPagination': false,
            'id': 'list-billing-invoices',
            'length': 10000,
            'graphQL': {
                'queryType': 'billingInvoices',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'onDrawLine': function($line,item,index){
                if(item.node.ttc < 0){
                    $line.addClass('tr-danger');
                }
            },
            'columns': [
                {
                    'name': 'reference',
                    'label': window.translate('billing.invoice.reference.label'),
                    'class': 'billing-invoice-reference',
                    'render': function(item,index){
                        return item.node.reference;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('billing.invoice.date.label'),
                    'class': 'billing-invoice-date',
                    'render': function(item,index){
                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'customer',
                    'label': window.translate('billing.invoice.customer.label'),
                    'class': 'billing-invoice-customer',
                    'render': function(item,index){
                        return item.node.customer ? item.node.customer.name : item.node.customerName;
                    },
                },
                {
                    'name': 'ht',
                    'label': window.translate('billing.invoice.ht.label'),
                    'class': 'billing-invoice-ht',
                    'render': function(item,index){
                        return window.formatFloat(item.node.ht) + ' &euro;';
                    },
                },
                {
                    'name': 'tva55',
                    'label': window.translate('billing.invoice.tva55.label'),
                    'class': 'billing-invoice-tva55',
                    'render': function(item,index){
                        return window.formatFloat(item.node.computedTva55) + ' &euro;';
                    },
                },
                {
                    'name': 'tva20',
                    'label': window.translate('billing.invoice.tva20.label'),
                    'class': 'billing-invoice-tva20',
                    'render': function(item,index){
                        return window.formatFloat(item.node.computedTva20) + ' &euro;';
                    },
                },
                {
                    'name': 'ttc',
                    'label': window.translate('billing.invoice.ttc.label'),
                    'class': 'billing-invoice-ttc',
                    'render': function(item,index){
                        return window.formatFloat(item.node.ttc) + ' &euro;';
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'billing-invoice-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

                        //print = retour de PDF
                        let dropdownBtnId = 'dropdownPrintBtn'+item.node.id;

                        let $btnDownloadWithHeader = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-text dropdown-item')
                        .addClass('btn-download btn-invoice-download')
                        .attr('data-invoice',item.node.id)
                        .attr('data-no-head',false)
                        .append(window.translate('app.billing.invoice.actions.print.withHeader'))
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickDownloadInvoice($btn);
                        });

                        let $btnDownloadWithoutHeader = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-text dropdown-item')
                        .addClass('btn-download btn-invoice-download')
                        .attr('data-invoice',item.node.id)
                        .attr('data-no-head',true)
                        .append(window.translate('app.billing.invoice.actions.print.withoutHeader'))
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickDownloadInvoice($btn);
                        });


                        let $dropdownPrint = $('<div/>')
                        .addClass('dropdown')
                        .append(
                            $('<button/>')
                            .attr('id',dropdownBtnId)
                            .attr('type',"button")
                            .attr('data-bs-toggle',"dropdown")
                            .attr('aria-expanded',"false")
                            .addClass('btn btn-text text-primary')
                            .addClass('dropdown-toggle')
                            .attr('title',window.translate('app.billing.invoice.actions.print.label'))
                            .append(
                                $('<i/>')
                                .addClass('fa fa-print')
                            )
                        )
                        .append(
                            $('<ul/>')
                            .addClass('dropdown-menu p-2')
                            .attr('aria-labelledby',dropdownBtnId)
                            .append(
                                $('<li/>')
                                .append($btnDownloadWithHeader)
                                //.append(
                                //    $('<a/>')
                                //    .attr('download','download')
                                //    .addClass('btn btn-text dropdown-item')
                                //    .attr('target','_blank')
                                //    .attr('href',window.App.get('oldAdminHomeUrl')+"/billing/downloadInvoice/simple/&type=1&id="+item.node.id)
                                //    .append(window.translate('app.billing.invoice.actions.print.withHeader'))
                                //)
                                .append($btnDownloadWithoutHeader)
                                //.append(
                                //    $('<a/>')
                                //    .attr('download','download')
                                //    .addClass('btn btn-text dropdown-item')
                                //    .attr('target','_blank')
                                //    .attr('href',window.App.get('oldAdminHomeUrl')+"/billing/downloadInvoice/simple/&type=2&id="+item.node.id)
                                //    .append(window.translate('app.billing.invoice.actions.print.withoutHeader'))
                                //)
                            )
                        )
                        btns.push($dropdownPrint);


                        let $btnSend = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-primary')
                        .attr('title',window.translate('app.billing.invoice.actions.send.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-envelope')
                        )
                        .on('click',function(event){
                            self.onClickSend(item.node);
                        });
                        btns.push($btnSend);

                        let urlLevies = self.settings.billingPaymentListBaseUrl + '?invoice=' + item.node.id;
                        let $btnLevies = $('<a/>')
                        .attr('href',urlLevies)
                        .addClass('btn btn-link text-primary')
                        .attr('title',window.translate('app.billing.invoice.actions.levies.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-euro-sign')
                        );
                        btns.push($btnLevies);

                        let $btnRegenerate = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-primary')
                        .attr('title',window.translate('app.billing.invoice.actions.regenerate.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-sync')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickRegenerate(item.node,$btn);
                        });
                        btns.push($btnRegenerate);


                        if(item.node.locked){
                            let $btnUnlock = $('<button/>')
                            .attr('type','button')
                            .addClass('btn btn-link text-danger')
                            .attr('title',window.translate('app.billing.invoice.actions.unlock.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-lock-open-alt')
                            )
                            .on('click',function(event){
                                self.onClickUnlock(item.node);
                            });
                            btns.push($btnUnlock);
                        }else{

                            let urlEdit = self.settings.billingInvoiceShowBaseUrl.replace('__ID__',item.node.id);
                            let $btnEdit = $('<a/>')
                            .attr('href',urlEdit)
                            .addClass('btn btn-link')
                            .attr('title',window.translate('app.billing.invoice.actions.edit.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-edit')
                            );
                            btns.push($btnEdit);

                            let $btnDelete = $('<button/>')
                            .attr('type','button')
                            .addClass('btn btn-link text-danger')
                            .attr('title',window.translate('app.billing.invoice.actions.delete.label'))
                            .append(
                                $('<i/>')
                                .addClass('fas fa-trash')
                            )
                            .on('click',function(event){
                                self.onClickDelete(item.node);
                            });
                            btns.push($btnDelete);
                        }

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildFooter(data){
        let $row = $('<tr/>');

        if(data.length <= 1){
            return '';
        }

        let totalHt = 0;
        let totalTva55 = 0;
        let totalTva20 = 0;
        let totalTtc = 0;

        for(var i in data){
            let item = data[i].node;
            totalHt += parseFloat(item.ht);
            totalTva55 += parseFloat(item.computedTva55);
            totalTva20 += parseFloat(item.computedTva20);
            totalTtc += parseFloat(item.ttc);
        }

        $row
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append(window.translate('total'))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalHt) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalTva55) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalTva20) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(totalTtc) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )

        return $row;
    }

    buildGraphQLParameters(){
        let filters = {
            'customerType': 'Restaurant'
        };

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = this.$filterByReference.val();
        }
        else if(this.$filterByDeliveryNumber && this.$filterByDeliveryNumber.val()){
            filters.deliveryNumber = this.$filterByDeliveryNumber.val();
        }
        else{
            if( this.$filterByDateFrom.val() && this.$filterByDateTo.val()){
                let from = this.$filterByDateFrom.val();
                let to = this.$filterByDateTo.val();

                filters.date = 'BETWEEN '+from+' '+to;
            }

            if(this.$filterBySearch && this.$filterBySearch.val()){
                filters.search = this.$filterBySearch.val();
            }


            if(this.$filterByType && this.$filterByType.val()){
                filters.type = parseInt(this.$filterByType.val());
            }

            if(this.$filterByRestaurant && this.$filterByRestaurant.val()){
                filters.restaurant = parseInt(this.$filterByRestaurant.val());
            }
        }

        let orderBy = 'date';
        let dir = "ASC";

        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    bindEvents(){
        var self = this;
        this.$btnExportLevies.on('click',this.onClickExportLevies);

        $('.btn-billing-invoice-export',this.$container).on('click',function(event){

            event.stopPropagation();
            event.preventDefault();

            let $btn = $(this);
            self.onClickBtnExport($btn);
        });

        if(this.$btnGenerateInvoices.length > 0){
            this.$btnGenerateInvoices.on('click',function(event){
                event.preventDefault();
                event.stopPropagation();

                let $btn = $(this);
                self.onClickGenerateInvoices($btn);
            });
        }
    }

    onClickExportLevies(event){
        event.preventDefault();
        event.stopPropagation();

        let baseUrl = window.App.get('oldAdminHomeUrl') + '/billing/downloadPrelevements/simple';

        let from = moment(this.$filterByDateFrom.val()).format('DD/MM/YYYY');
        let to = moment(this.$filterByDateTo.val()).format('DD/MM/YYYY');

        let url = baseUrl + '?exportB='+from+'&exportE='+to;

        let modal = new IFrame({
            'modalSize': 'full',
            'url': url,
        });
        modal.show();
    }

    onClickDelete(invoice){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.billing.invoice.actions.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(invoice,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();

    }

    proceedDelete(invoice,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'id': {
                'value': invoice.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteBillingInvoice",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                confirmModal.hide();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.hide();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onClickUnlock(invoice){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.billing.invoice.actions.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-warning btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedUnlock(invoice,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();

    }

    proceedUnlock(invoice,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'id': {
                'value': invoice.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "UnlockBillingInvoice",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                confirmModal.hide();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.hide();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onClickSend(item){
        let modal = new SendModal({
            'invoice': item,
        });
    }

    onClickRegenerate(item,$btn){
        var self = this;

        $btn.addClass('fa-spin');

        let id = item.id;
        let mutation = new GraphQLMutation({
            'mutationType': "RegenerateBillingInvoice",
            'fields': [
                'success',
                'message',
                'errors { key, value }',
            ],
            'variables': {
                'id': {
                    'value': id,
                    'type': 'Int!'
                }
            },
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                $btn.removeClass('fa-spin');
            }
        });

        mutation.execute();

        //$.ajax({
        //    'url': window.App.get('oldAdminHomeUrl')+'/billing/regenerateInvoice/simple/',
        //    'method': 'POST',
        //    'data': {
        //        'id': item.id
        //    }
        //})
        //.always(function(){
        //    $btn.removeClass('fa-spin');
        //    // but since done/fail not working because we get an infinite redirection loop (so always assume it's ok)
        //    window.notify(window.translate('app.billing.invoice.actions.regenerate.succeed'),'success');
        //})
    }

    onClickBtnExport($btn){

        let format = $btn.data('format');

        let modal = new ExportModal({
            'format': format,
            'parameters': this.buildGraphQLParameters(),
        });
    }

    onClickDownloadInvoice($btn){
        var self =this;
        
        let id = parseInt($btn.data('invoice'));
        let noHead = $btn.data('no-head') ? true : false;
        let waitingModal = new WaitingModal();

        let mutation = new GraphQLMutation({
            'mutationType': "DownloadBillingInvoice",
            'fields': [
                'success',
                'message',
                'file { url }',
                'errors { key, value }',
            ],
            'variables': {
                'id': {
                    'value': id,
                    'type': 'Int!'
                },
                'noHead': {
                    'value': noHead,
                    'type': 'Boolean!'
                }
            },
            'before': function(){
                waitingModal.show();
            },
            'success': function(data){
                let url = window.App.get('apiBaseUrl')+data.file.url;
                window.open(url);
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                waitingModal.dispose();
            }
        });

        mutation.execute();
    }

    onClickGenerateInvoices($btn){
        var self = this;
        $btn.attr('disabled','disabled');
        $('i',$btn).addClass('fa-spin');
        let nbBillingRemaining = this.$btnGenerateInvoices.data('nb');
        this.generateInvoices(nbBillingRemaining);
    }

    generateInvoices(nb){
        var self = this;
        let baseUrl = window.App.get('oldAdminBaseUrl');
        let script = '/generate_invoices/scripts&isClicked=true';

        let url = baseUrl + script;
        

        $.ajax({
            'url': url,
            'method': 'GET',
            'data': {
            }
        })
        .done(function(response){
            if(response.includes('_locked')){
                window.notify("Le script de génération est en cours, veuillez patienter avant de le relancer (environ 5 minutes)","info");
                self.$btnGenerateInvoices.removeAttr('disabled');
                $('i',self.$btnGenerateInvoices).removeClass('fa-spin');
            }else{
                let newNb = nb - 1;
                self.updateGenerationStatus(newNb);
                if(response.includes('_finished') || newNb <= 0){
                    window.notify("Toutes les factures en attente ont été générées","success");
                    self.doneGeneration();
                }else{
                    setTimeout(function(){
                        window.notify("Une facture a été générée, lancement de la suivante","info");
                        self.generateInvoices(newNb);
                    },1000);
                }
            }
        })
        .fail(function(){
            window.notify("Une erreur est survenue","danger");
        })
        .always(function(){
        });
    }

    updateGenerationStatus(newNb){
        this.$btnGenerateInvoices
        .attr('data-nb',newNb)
        .data('nb',newNb);
        let $wrapper = this.$btnGenerateInvoices.closest('.generate-invoices-container');
        let $nbContainer = $('.generate-invoices-nb',$wrapper);
        $nbContainer.html(newNb);
        if(newNb <= 0){
            $wrapper.remove();
        }else{
            self.refresh();
        }
    }

    doneGeneration(){
        let $wrapper = this.$btnGenerateInvoices.closest('.generate-invoices-container');
        $wrapper.remove();
        this.refresh();

    }
}

module.exports = ListView;

